import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import BrandingBanner from '../../common/branding_banner';
import OpenerImage from '../../common/opener_image';
import ProductListHeroContent from './hero_content';
import OpenerImagesPropTypes from '../../../utils/prop-types/OpenerImagesPropTypes';
import {
  ROW_TYPE_SHOPPING_HERO,
  GLOBAL_HEADER_CLASS_NAME
} from '../../../constants';
import {
  currentBreakpoint, nodeYScrollCoord, offsetHeight,
  querySelector, scrollTo, windowAttrs
} from '../../../utils/dom';
import {isEmpty, defer} from 'lodash';
import classNames from 'classnames';
import Link from 'react-router/lib/Link';

class ProductListHeroImage extends PureComponent {
  componentDidMount() {
    this.scrollToHeroImage();
  }

  componentDidUpdate() {
    this.scrollToHeroImage();
  }

  scrollToHeroImage = () => {
    if (
      currentBreakpoint() !== 'desktop'
      || this.props.isShoppingHome
    ) {
      return;
    }

    /*
     * We want to scroll to the hero image. But we should `defer` it.
     * We need the height of `this.container` to figure out where to scroll,
     * and that height on mount is 0.
     *
     * I think (but am not sure) that this is because the height is determined
     * by the image's height.
     *
     * This height is correct after the execution of the current call
     * stack.
     */
    defer(() => {
      const globalHeaderHeight =
        querySelector('.' + GLOBAL_HEADER_CLASS_NAME).offsetHeight;
      const halfContainerHeight = offsetHeight(this.container) / 2;

      // Goal is to for the user to see the bottom 50% of the hero image
      const scrollTarget = nodeYScrollCoord(this.container, window)
        + halfContainerHeight - globalHeaderHeight;

      // Don't bother if the user can already see our beautiful product cards
      if (windowAttrs().scrollTop >= scrollTarget) {
        return;
      }

      scrollTo(0, scrollTarget);
    });
  }

  setContainerRef = element => {
    this.container = element;
  }

  heroImageHeader() {
    const { openerImages, heroImage } = this.props;

    if (openerImages && !isEmpty(openerImages)) {
      return (
        <OpenerImage
          opener_images={openerImages}
          rowType={ROW_TYPE_SHOPPING_HERO}
        />
      );
    }

    if (heroImage) {
      return <img src={heroImage} />;
    }

    return null;
  }

  render() {
    const {
      heroImage,
      logoImage,
      openerImages,
      pageTitle,
      categoryType,
      brandingBanner,
      featuredCollectionUrl,
      featuredCollectionName
    } = this.props;

    let heroContent;

    if (pageTitle) {
      heroContent = (
        <ProductListHeroContent
          pageTitle={pageTitle}
          categoryType={categoryType}
          logoImage={logoImage}
          featuredCollectionName={featuredCollectionName}
        />
      );
    }

    return (
      <div className="hero-image" ref={this.setContainerRef}>
        <div className={classNames(
          'hero-image-header',
          (!openerImages || isEmpty(openerImages)) && heroImage && 'fixed-height'
        )}
        >
          {this.heroImageHeader()}
          {
            featuredCollectionUrl
              ? <Link to={featuredCollectionUrl}>
                <div className="hero-overlay"/>
                {heroContent}
              </Link>
              : <div>
                <div className="hero-overlay"/>
                {heroContent}
              </div>
          }
        </div>
        {brandingBanner &&
          <BrandingBanner
            type="campaign"
            src={brandingBanner}
          />
        }
      </div>
    );
  }
}

ProductListHeroImage.propTypes = {
  heroImage: PropTypes.string,
  logoImage: PropTypes.string,
  openerImages: OpenerImagesPropTypes,
  pageTitle: PropTypes.string,
  categoryType: PropTypes.string,
  brandingBanner: PropTypes.string,
  featuredCollectionUrl: PropTypes.string,
  featuredCollectionName: PropTypes.string,
  isShoppingHome: PropTypes.bool.isRequired
};

export default ProductListHeroImage;
